import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs';

import { ConfirmationCallerCallBack } from '../bloc/confiramtion-modal-bloc';
import { ConfirmationPopupDataObject } from '../interfaces';
import { PopupComponent } from '../component/popup/popup.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationPopupService {

  constructor() { }

  public onOpenConfirmation<T>( dialog: MatDialog,
    template: TemplateRef<any>,
    caller: ConfirmationCallerCallBack<T>,
    title?: string,
    body?: string )
  {
    const data : ConfirmationPopupDataObject<T> = {
        caller : caller ,
        data : {
          body : body
        }
    }
    const dialogRef = dialog.open(PopupComponent<any, any>, {
      width: '500px',
      disableClose: true,
      data: {
        title: title,
        data: data,
      },
    });
    dialogRef.componentInstance.template = template;
    return dialogRef
      .afterClosed()
      .pipe(map(res=>res))
  }
}
